import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Col, Divider, Form, Row } from 'antd'
import { stubFalse } from 'lodash'
import PropTypes from 'prop-types'

import {
  FormButtons,
  FormTreeSelect,
} from '../../../common/components/sections'
import { StyledPaddingTopCol } from '../../../common/components/styled'
import { PERMISSIONS } from '../../../common/constants'
import { createTreeSelectOptions } from '../../../common/helpers'
import { useFormDirty } from '../../../common/hooks'

import { targetedDbFlashFormInitialValues } from './initial-values'

const TargetedDbFlashForm = ({ isLoading, isDisabled, onSubmit }) => {
  const [form] = Form.useForm()
  const { isDirty, setToDirty, resetForm } = useFormDirty(form)

  const initialValues = useMemo(() => targetedDbFlashFormInitialValues(), [])

  const { dishTypes } = useSelector(store => store.common.metadata.data)

  // const handleTagRender = useCallback(
  //   tag => {
  //     const { onClose, label, value: tagValue } = tag
  //     const isSuggestedByAi = some(highlightedLanguageIds, highlightedId =>
  //       areSameValue(highlightedId, tagValue),
  //     )

  //     return (
  //       <StyledAiHighlightedTag
  //         onClose={onClose}
  //         closable
  //         isSuggestedByAi={isSuggestedByAi}
  //       >
  //         {label}
  //       </StyledAiHighlightedTag>
  //     )
  //   },
  //   [highlightedLanguageIds],
  // )

  const dishTypeTreeOptionsWithAllNodesActive = useMemo(
    () =>
      createTreeSelectOptions(dishTypes, 'name', 'id', stubFalse, [
        'isIgnored',
        'courseTypeId',
        'level',
      ]),
    [dishTypes],
  )

  useEffect(() => {
    resetForm()
  }, [initialValues, resetForm])

  return (
    <Form
      form={form}
      initialValues={initialValues}
      name="targetedDbFlashForm"
      onFinish={onSubmit}
      autoComplete="off"
      onFieldsChange={setToDirty}
    >
      <Row gutter={[16]}>
        <Col span={8}>
          <FormTreeSelect
            allowClear
            name="dishTypeIds"
            label="Dish types"
            labelAbove
            placeholder="Select dish types..."
            treeData={dishTypeTreeOptionsWithAllNodesActive}
            multiple
            disabled={isDisabled}
          />
        </Col>
        <StyledPaddingTopCol span={6}>
          <FormButtons
            permissions={[
              PERMISSIONS.MENU_CURATION_TASK.UPDATE_DETAIL_LEVEL,
              PERMISSIONS.MENU_CURATION_TASK.UPDATE,
            ]}
            isDisabled={!isDirty}
            isLoading={isLoading}
            onReset={resetForm}
          />
        </StyledPaddingTopCol>
      </Row>
      <Divider />
    </Form>
  )
}

TargetedDbFlashForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

TargetedDbFlashForm.defaultProps = {
  isLoading: false,
  isDisabled: false,
}

export default TargetedDbFlashForm
